export function jsonPathFromFilters(filters) {
  const jsonPath = '$';

  const filterStrings = filters.map((filter) => ` ? (@.${filter.id} like_regex "${filter.value}")`);

  return jsonPath.concat(...filterStrings);
}

export function filtersFromJsonPath(jsonPath) {
  const conditions = jsonPath.split('?');
  const re = /@\.(.*) like_regex "(.*)"/;

  return conditions.reduce((acc, val) => {
    const m = re.exec(val);
    const key = m ? m[1] : null;
    const value = m ? m[2] : null;

    if (!key || !value) {
      return;
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});
}

export function generateFilterObject(rowData, jsonPath) {
  const setFilters = filtersFromJsonPath(jsonPath);
  return Object.keys(setFilters).map((key) => ({
    id: key,
    value: setFilters[key],
  }));
}

export function setFilterInArray(filters, newFilter) {
  if (filters.length === 0) {
    return [newFilter];
  }
  return filters.map((filter) => {
    if (filter.id) {
      return { id: newFilter.id, value: newFilter.value };
    }
    return filter;
  });
}
